var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctAddress, FctString, FctTradingGraphProps, FctValue } from '../../../Fct/generics';
import { weiToCurrency } from '../../../Fct/helpers';
import { getAllSupportedTokens } from '../curve/helpers/supportedContracts';
export var TradingGraph = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'GETTER',
    method: 'tradingGraph',
    name: 'tradingGraph',
    flowType: 'OFFCHAIN_ONLY',
    initParams: {
        protocol: 'uniswapv2',
    },
    getParams: function (_a) {
        var chainId = _a.chainId;
        var tokens = getAllSupportedTokens(chainId);
        return {
            input: {
                label: new FctString({ required: false }),
                fromToken: new FctAddress({ required: false, options: tokens }),
                toToken: new FctAddress({ required: false, options: tokens }),
                protocol: new FctString({ required: false, hidden: true, value: 'uniswapv2' }),
                minPrice: new FctValue({ required: false }),
                minDescription: new FctString({ required: false }),
                maxPrice: new FctValue({ required: false }),
                maxDescription: new FctString({ required: false }),
                methodParams: {},
            },
            output: {
                component: new FctTradingGraphProps({
                    required: false,
                    description: 'trading graph component',
                    destination: 'trading_graph_component',
                }),
            },
        };
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, output = _a.output;
        var getProps = function () { return __awaiter(void 0, void 0, void 0, function () {
            var label, protocol, fromToken, toToken, maxPrice, minPrice, minDescription, maxDescription, component, getParamValue, getAmount;
            return __generator(this, function (_a) {
                label = input.label, protocol = input.protocol, fromToken = input.fromToken, toToken = input.toToken, maxPrice = input.maxPrice, minPrice = input.minPrice, minDescription = input.minDescription, maxDescription = input.maxDescription;
                component = output.component;
                getParamValue = function (param) {
                    if (param.isVariable)
                        return param.estimatedValue;
                    return param.value;
                };
                getAmount = function (initValue, decimals) {
                    if (!initValue)
                        return initValue;
                    if (!decimals)
                        return initValue;
                    if (initValue === '0')
                        return initValue;
                    return weiToCurrency(initValue, decimals);
                };
                if (!component.value) {
                    component.value = {};
                }
                if (typeof component.value === 'string') {
                    try {
                        component.value = JSON.parse(component.value);
                    }
                    catch (e) {
                        component.value = {};
                    }
                }
                if (!component.value)
                    component.value = {};
                component.value.label = getParamValue(label);
                component.value.fromToken = getParamValue(fromToken);
                component.value.toToken = getParamValue(toToken);
                component.value.protocol = getParamValue(protocol);
                component.value.maxPrice = getAmount(getParamValue(maxPrice), maxPrice.decimals);
                component.value.minPrice = getAmount(getParamValue(minPrice), minPrice.decimals);
                component.value.fromSymbol = fromToken.symbol;
                component.value.toSymbol = toToken.symbol;
                component.value.fromDecimals = fromToken.decimals;
                component.value.toDecimals = toToken.decimals;
                component.value.minDescription = getParamValue(minDescription);
                component.value.maxDescription = getParamValue(maxDescription);
                return [2 /*return*/, {
                        params: {
                            label: label.value,
                            protocol: protocol.value,
                            fromToken: fromToken.value,
                            toToken: toToken.value,
                            maxPrice: maxPrice.value,
                            minPrice: minPrice.value,
                            minDescription: minDescription.value,
                            maxDescription: maxDescription.value,
                        },
                        error: undefined,
                    }];
            });
        }); };
        return {
            get: getProps,
            depParamKeys: [
                'label',
                'protocol',
                'fromToken',
                'toToken',
                'maxPrice',
                'minPrice',
                'minDescription',
                'maxDescription',
            ],
        };
    },
});
